export class HighlightMatchTextHelper {
  public static highlightMatchText(text: string, filterValue: string): string {
    if (!text) return '';

    const valueToMatch = filterValue ?? '';
    if (!valueToMatch.length) return text;

    const safeText = this.escapeHtml(text);
    const escapedFilterValue = this.escapeRegExp(valueToMatch);
    const regex = new RegExp(`(${escapedFilterValue})`, 'gi');

    return safeText.replace(regex, '<strong class="frm-color-blue">$1</strong>');
  }

  private static escapeHtml(unsafe: string): string {
    return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  private static escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
